export const products = [
  {
    id: 'p1',
    name: '缤纷水果硬糖礼罐',
    category: 'fruit-candy',
    price: 39.90,
    originalPrice: 49.90,
    image: 'https://readdy.ai/api/search-image?query=Colorful%20fruit%20flavored%20hard%20candies%20in%20a%20glass%20jar%2C%20orange%20lemon%20strawberry%20grape%20flavors%2C%20translucent%20candy%20pieces%2C%20bright%20natural%20light%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20vibrant%20colors&width=600&height=600&seq=candy-prod-01&orientation=squarish',
    badge: '热卖',
    description: '精选六种水果风味硬糖，采用天然果汁调味，酸甜可口，罐装密封保鲜',
    rating: 4.8,
    reviews: 256,
  },
  {
    id: 'p2',
    name: '进口巧克力夹心糖',
    category: 'chocolate-candy',
    price: 68.00,
    originalPrice: 85.00,
    image: 'https://readdy.ai/api/search-image?query=Premium%20imported%20chocolate%20filled%20candies%20with%20assorted%20centers%2C%20smooth%20dark%20chocolate%20shell%2C%20elegant%20presentation%20on%20white%20surface%2C%20professional%20gourmet%20food%20photography%2C%20rich%20brown%20tones%2C%20luxurious%20feel&width=600&height=600&seq=candy-prod-02&orientation=squarish',
    badge: '新品',
    description: '比利时进口巧克力，包裹多种口味夹心，丝滑醇厚，入口即化',
    rating: 4.9,
    reviews: 189,
  },
  {
    id: 'p3',
    name: '小熊造型果汁软糖',
    category: 'gummy-candy',
    price: 25.90,
    originalPrice: 32.90,
    image: 'https://readdy.ai/api/search-image?query=Cute%20bear%20shaped%20gummy%20candies%20in%20multiple%20colors%2C%20fruit%20juice%20flavored%2C%20translucent%20and%20chewy%20texture%2C%20scattered%20on%20white%20surface%2C%20playful%20composition%2C%20professional%20macro%20food%20photography%2C%20vibrant%20and%20fun&width=600&height=600&seq=candy-prod-03&orientation=squarish',
    badge: '爆款',
    description: '可爱小熊造型，添加真实果汁，Q弹有嚼劲，小朋友的最爱',
    rating: 4.7,
    reviews: 423,
  },
  {
    id: 'p4',
    name: '彩虹螺旋大棒棒糖',
    category: 'lollipop',
    price: 12.90,
    originalPrice: 16.90,
    image: 'https://readdy.ai/api/search-image?query=Large%20rainbow%20swirl%20lollipop%20with%20vibrant%20colorful%20spiral%20pattern%2C%20standing%20on%20white%20background%2C%20professional%20product%20photography%2C%20glossy%20surface%2C%20bright%20and%20cheerful%2C%20nostalgic%20candy%20aesthetic&width=600&height=600&seq=candy-prod-04&orientation=squarish',
    badge: '',
    description: '经典彩虹螺旋造型，直径8cm超大棒棒糖，缤纷色彩，甜蜜持久',
    rating: 4.6,
    reviews: 312,
  },
  {
    id: 'p5',
    name: '臻选糖果礼盒套装',
    category: 'gift-box',
    price: 168.00,
    originalPrice: 218.00,
    image: 'https://readdy.ai/api/search-image?query=Premium%20candy%20gift%20box%20set%20with%20beautiful%20packaging%20and%20satin%20ribbon%2C%20assorted%20luxury%20sweets%20and%20chocolates%20inside%2C%20elegant%20presentation%20on%20soft%20cream%20background%2C%20professional%20product%20photography%2C%20gift%20concept&width=600&height=600&seq=candy-prod-05&orientation=squarish',
    badge: '推荐',
    description: '12款精选糖果组合，高档礼盒包装，附赠手写贺卡，送礼体面大气',
    rating: 5.0,
    reviews: 87,
  },
  {
    id: 'p6',
    name: '散装混合水果糖5斤装',
    category: 'bulk-candy',
    price: 89.00,
    originalPrice: 118.00,
    image: 'https://readdy.ai/api/search-image?query=Large%20bulk%20bag%20of%20mixed%20fruit%20candies%2C%20assorted%20colors%20and%20shapes%2C%20value%20size%20packaging%2C%20clean%20white%20background%2C%20professional%20commercial%20product%20photography%2C%20abundant%20and%20colorful%20display&width=600&height=600&seq=candy-prod-06&orientation=squarish',
    badge: '划算',
    description: '混合口味水果糖大包装，5斤实惠装，适合派对、婚庆、店铺批发',
    rating: 4.5,
    reviews: 534,
  },
  {
    id: 'p7',
    name: '草莓牛奶夹心软糖',
    category: 'gummy-candy',
    price: 29.90,
    originalPrice: 38.90,
    image: 'https://readdy.ai/api/search-image?query=Pink%20strawberry%20milk%20filled%20soft%20candies%2C%20creamy%20center%20visible%2C%20pastel%20pink%20color%2C%20sweet%20and%20cute%20presentation%20on%20white%20surface%2C%20professional%20food%20photography%2C%20soft%20lighting%2C%20kawaii%20aesthetic&width=600&height=600&seq=candy-prod-07&orientation=squarish',
    badge: '人气',
    description: '草莓与牛奶的经典组合，外层Q弹软糖包裹丝滑奶油夹心',
    rating: 4.8,
    reviews: 198,
  },
  {
    id: 'p8',
    name: '纯可可脂黑巧克力豆',
    category: 'chocolate-candy',
    price: 45.90,
    originalPrice: 55.90,
    image: 'https://readdy.ai/api/search-image?query=Dark%20chocolate%20coated%20candy%20pellets%20with%20cocoa%20dusting%2C%20rich%20dark%20brown%20color%2C%20elegant%20arrangement%20on%20white%20surface%2C%20professional%20gourmet%20food%20photography%2C%20minimalist%20and%20sophisticated&width=600&height=600&seq=candy-prod-08&orientation=squarish',
    badge: '',
    description: '72%纯可可脂黑巧克力豆，微苦回甘，巧克力爱好者的品质之选',
    rating: 4.7,
    reviews: 145,
  },
  {
    id: 'p9',
    name: '柠檬薄荷清凉糖',
    category: 'fruit-candy',
    price: 19.90,
    originalPrice: 26.90,
    image: 'https://readdy.ai/api/search-image?query=Yellow%20lemon%20mint%20flavored%20candies%20with%20cooling%20sensation%2C%20translucent%20yellow%20color%2C%20refreshing%20look%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20bright%20and%20fresh%20composition&width=600&height=600&seq=candy-prod-09&orientation=squarish',
    badge: '',
    description: '柠檬与薄荷的清新组合，提神醒脑，饭后清口必备小零食',
    rating: 4.4,
    reviews: 267,
  },
  {
    id: 'p10',
    name: '节日限定糖果大礼包',
    category: 'gift-box',
    price: 298.00,
    originalPrice: 398.00,
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20festival%20limited%20edition%20candy%20hamper%20with%20red%20and%20gold%20packaging%2C%20premium%20assorted%20sweets%20and%20chocolates%2C%20festive%20presentation%2C%20elegant%20gift%20giving%20concept%20on%20soft%20cream%20background%2C%20professional%20product%20photography&width=600&height=600&seq=candy-prod-10&orientation=squarish',
    badge: '限定',
    description: '节日限定豪华大礼包，30款精选糖果，奢华包装，送礼自用两相宜',
    rating: 5.0,
    reviews: 63,
  },
  {
    id: 'p11',
    name: '七彩星星棒棒糖套装',
    category: 'lollipop',
    price: 22.90,
    originalPrice: 29.90,
    image: 'https://readdy.ai/api/search-image?query=Set%20of%20colorful%20star%20shaped%20lollipops%20in%20various%20bright%20colors%2C%20standing%20in%20a%20row%20on%20white%20background%2C%20glossy%20and%20shiny%20surface%2C%20professional%20product%20photography%2C%20playful%20and%20fun%20composition&width=600&height=600&seq=candy-prod-11&orientation=squarish',
    badge: '套装',
    description: '七彩星星造型棒棒糖套装，7支不同口味，派对礼物首选',
    rating: 4.6,
    reviews: 178,
  },
  {
    id: 'p12',
    name: '散装什锦软糖10斤装',
    category: 'bulk-candy',
    price: 148.00,
    originalPrice: 198.00,
    image: 'https://readdy.ai/api/search-image?query=Large%20bulk%20pack%20of%20assorted%20gummy%20candies%20in%20various%20shapes%20colors%20and%20flavors%2C%20commercial%20size%20packaging%2C%20abundant%20colorful%20display%2C%20clean%20white%20background%2C%20professional%20wholesale%20product%20photography&width=600&height=600&seq=candy-prod-12&orientation=squarish',
    badge: '超值',
    description: '10斤装什锦软糖批发装，多种口味随机搭配，性价比之选',
    rating: 4.5,
    reviews: 389,
  },
];

export const getProductsByCategory = (categorySlug: string) => {
  return products.filter((p) => p.category === categorySlug);
};

export const getProductById = (id: string) => {
  return products.find((p) => p.id === id);
};

export const getFeaturedProducts = () => {
  return products.filter((p) => p.badge === '热卖' || p.badge === '爆款' || p.badge === '推荐');
};